import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

(function (Drupal) {
  Drupal.behaviors.niquelQuimicoTitleImages = {
    attach(context) {
      const block = context.querySelector('#bloque-niquel-quimico');
      if (!block || block.dataset.gsapInit) return;
      block.dataset.gsapInit = '1';

      const imgs = block.querySelectorAll('.title-image img');
      if (!imgs.length) return;

      // Esperar a que carguen (evita flashes si son lazy)
      const waitLoads = Array.from(imgs).map(img =>
        img.complete
          ? Promise.resolve()
          : new Promise(res => {
              img.addEventListener('load', res, { once: true });
              img.addEventListener('error', res, { once: true });
            })
      );

      Promise.all(waitLoads).then(() => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        gsap.fromTo(
          imgs,
          { autoAlpha: 0, yPercent: reduce ? 0 : 20, scale: reduce ? 1 : 0.96, rotate: reduce ? 0 : -1.5 },
          {
            autoAlpha: 1,
            yPercent: 0,
            scale: 1,
            rotate: 0,
            duration: 0.7,
            ease: 'power3.out',
            stagger: 0.1,
            scrollTrigger: {
              trigger: block,       // El bloque dispara la animación
              start: 'top 75%',     // Cuando el top del bloque está al 75% de la pantalla
              once: false           // Solo una vez
            }
          }
        );
      });
    }
  };
})(Drupal);